<template>
    <CardSelectItem
        :value="option.uuid"
        :disabled="notAvailable"
        :is-visible="isVisible">
        <div class="d-flex flex-column">
            {{ option.optionValue }}
            <small
                v-if="notAvailable"
                class="text-muted">{{ $t('eventRegistration.questions.notAvailable') }}</small>
            <BaseTooltip
                v-else-if="showAvailability"
                :content="$t('eventRegistration.questions.reservedPlaces', {amount: availability})"
                size="lg">
                <small
                    title="Verfügbare Plätze"
                    class="text-muted">noch {{ availability }}</small>
            </BaseTooltip>
        </div>
    </CardSelectItem>
</template>

<script>
import ruleBuilderComparisionElementsMixin from "@/mixins/registration/ruleBuilderComparisionElementsMixin";
import {RuleBuilderEvaluator} from '@farbcodegmbh/amosweb-rulebuilder'

export default {
    name: "AnswerSelectItem",
    mixins: [ruleBuilderComparisionElementsMixin],
    props: {
        option: {
            type: Object,
            required: true
        },
        answer: {
            type: Array
        },
        registrarMode: {
            type: Boolean,
            required: true
        },
        personKey: {
            type: [String, Number],
            required: true
        },
        questionKey: {
            type: [String, Number],
            required: true
        }
    },
    computed: {
        isVisible() {
            if (!this.option.visibilityConditions) {
                return true
            }
            const evaluator = new RuleBuilderEvaluator(
                {
                    ...this.getRegistrarQuestionsForRuleBuilderEvaluator,
                    ...this.registrarMode && this.getRegistrarRegistrationDateForRuleBuilder,
                    ...!this.registrarMode && this.getParticipantQuestionsForRuleBuilderEvaluator,
                    ...!this.registrarMode && this.getParticipantDataForRuleBuilderEvaluator,
                    ...!this.registrarMode && this.getCaregiverForRuleBuilderEvaluator
                },
                false
            )
            return evaluator.evaluateRule(this.option.visibilityConditions)
        },
        getParticipantQuestionsForRuleBuilderEvaluator() {
            return this.getQuestionsForRuleBuilderEvaluator(this.personKey)
        },
        getParticipantDataForRuleBuilderEvaluator() {
            return this.getPersonDataForRuleBuilderEvaluator(this.personKey)
        },

        getAnswerSelectionsInRegistration() {
            return this.$store.getters['registration/getAnswerSelectionsInRegistration']
        },

        getQuestionAnswerSelectionInRegistration() {
            return this.$store.getters['registration/getQuestionAnswerSelectionInRegistration'](this.questionKey, this.option.uuid)
        },

        person() {
            return this.registrationData.persons[this.personKey]
        },
        availabilities() {
            return this.$store.state?.registration?.availabilities ?? {}
        },
        availability() {
            return this.availabilities[this.option?.uuid] ?? null
        },
        showAvailability() {
            return (this.availability && this.option?.showRemaining)
        },
        reservedAvailabilities() {
            return this.$store.state?.registration?.reservedAvailabilities ?? {}
        },
        reservedAvailability() {
            return this.reservedAvailabilities[this.option?.uuid] ?? 0
        },
        restrictedByAvailability() {
            return this.availability !== null
        },
        selected() {
            return this.answer?.includes(this.option.uuid)
        },
        notAvailable() {
            return (!this.selected && this.restrictedByAvailability && (this.availability - this.reservedAvailability) <= this.getQuestionAnswerSelectionInRegistration)
        }
    }
}
</script>

<style scoped>

</style>
